import React, {useContext, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import ReportList from "./ReportList";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {updateCRStatus} from "../../../network/ra-detail/services/http.services";


type CustomerReportsProps = {
    raId: string,
}

export default function CustomerReports(props: CustomerReportsProps) {
    const {t} = useTranslation(['network', 'translation']);

    const [canBeConfirmed, setCanBeConfirmed] = useState(true);
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const handleConfirmButton = () => setShowConfirmPopup(true);
    const hideConfirmPopup = () => setShowConfirmPopup(false);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const ConfirmedStatus = '3';

    const [status, setStatus] = useState<string | null>(null);

    const handleSubmitConfirm = (raId: string) => {
        setCanBeConfirmed(false);
        updateCRStatus({ra_id: raId, status: 3}).then((response: any) => {
            //console.log("handleSubmitConfirm response:", response);
            if(response.data.status === ConfirmedStatus){
                viewMessage(t('raDetail.customerReports.successUpdateStatus'), snackbarTypes.success);
                setStatus(ConfirmedStatus);
            }else{
                viewMessage(t('raDetail.customerReports.errorUpdateStatus'), snackbarTypes.error);
                setCanBeConfirmed(true);
            }

        })
        .catch((error: any) => {
            console.error("Errore nel handleSubmitConfirm:", error);
            viewMessage(t('raDetail.customerReports.errorUpdateStatus'), snackbarTypes.error);
            setCanBeConfirmed(true);
        });
        hideConfirmPopup();
    }

        const viewMessage = (message: string, type = snackbarTypes.error) => {
            dispatchGlobalData({
                type: 'SET_SNACKBAR',
                payload: {
                    snackbar: {
                        message: t(message),
                        type: type,
                        show: true,
                        autoClose: true,
                    }
                }
            });
        }

    return (<>
        <Stack rowGap={2}>
            <Stack direction="row" justifyContent="end">
                {
                    <Button variant="outlined"
                            onClick={handleConfirmButton}
                            disabled={!canBeConfirmed} >
                        {t("raDetail.customerReports.confirm")}
                    </Button>
                }
            </Stack>

            <ReportList raId={props.raId} setCanBeConfirmed={setCanBeConfirmed} status={status}></ReportList>
        </Stack>

        <Dialog
            open={showConfirmPopup}
            onClose={hideConfirmPopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t("raDetail.customerReports.dialog.title")}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t("raDetail.customerReports.dialog.content")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>

                <Button onClick={hideConfirmPopup}  variant={"outlined"} color={"accent"}>
                    {t("raDetail.customerReports.dialog.action.cancel")}
                </Button>

                <Button onClick={() => handleSubmitConfirm(props.raId)} autoFocus>
                    {t("raDetail.customerReports.dialog.action.confirm")}
                </Button> 

            </DialogActions>
        </Dialog>
    </>)
}
